import { FC } from 'react'

import styled from 'styled-components'

import RightArrowIcon from 'src/Assets/Svg/pages-icons/RightArrow.svg?react'
import { IconButton } from 'src/Components/Buttons/IconButton'
import { SimpleLabel } from 'src/Components/SimpleLabel'
import { variables } from 'src/Styled/variables'

const Card = styled.div<{ $highlighted?: boolean }>`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 24px;
  border-radius: 16px;
  border: 1px solid
    ${({ theme, $highlighted }) =>
      $highlighted ? theme.color.brandGreen : theme.color.lightGrey};
  background: ${({ theme }) => theme.color.white};
  box-shadow: ${({ theme }) => theme.shadow.card};
  cursor: pointer;
`

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`

const Headline = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`

const Title = styled.span`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize18};
  font-style: normal;
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`

const Description = styled.span`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
`

export interface ReleaseTypeItemProps {
  title: string
  description: string
  labelText?: string
  onClick: () => void
}

export const ReleaseTypeItem: FC<ReleaseTypeItemProps> = ({
  title,
  description,
  labelText,
  onClick,
}) => (
  <Card $highlighted={Boolean(labelText)} onClick={onClick}>
    <Content>
      <Headline>
        <Title>{title}</Title>
        {Boolean(labelText) && (
          <SimpleLabel color='green'>{labelText}</SimpleLabel>
        )}
      </Headline>
      <Description>{description}</Description>
    </Content>
    <IconButton>
      <RightArrowIcon />
    </IconButton>
  </Card>
)
